var map = {
	"./TO_REPLACE-cover-img-1": 15073,
	"./TO_REPLACE-cover-img-1.jpg": 15073,
	"./TO_REPLACE-cover-img-2": 957,
	"./TO_REPLACE-cover-img-2.jpg": 957,
	"./TO_REPLACE-cover-img-3": 80545,
	"./TO_REPLACE-cover-img-3.jpg": 80545,
	"./TO_REPLACE-cover-img-4": 29131,
	"./TO_REPLACE-cover-img-4.jpg": 29131,
	"./TO_REPLACE-hero": 68090,
	"./TO_REPLACE-hero-redeem-lg": 34847,
	"./TO_REPLACE-hero-redeem-lg.jpg": 34847,
	"./TO_REPLACE-hero-redeem-sm": 69451,
	"./TO_REPLACE-hero-redeem-sm.jpg": 69451,
	"./TO_REPLACE-hero.jpg": 68090,
	"./TO_REPLACE-meastri-card-sm-placeholder": 64966,
	"./TO_REPLACE-meastri-card-sm-placeholder.jpg": 64966,
	"./TO_REPLACE-redeem-banner-img": 42997,
	"./TO_REPLACE-redeem-banner-img.jpg": 42997,
	"./TO_REPLACE-redeem-img-1": 90739,
	"./TO_REPLACE-redeem-img-1.jpg": 90739,
	"./TO_REPLACE-showreel-cover": 20947,
	"./TO_REPLACE-showreel-cover.jpg": 20947,
	"./agatha/estate-logo": 74247,
	"./agatha/estate-logo.png": 74247,
	"./agatha/first": 28762,
	"./agatha/first.webp": 28762,
	"./agatha/second": 21970,
	"./agatha/second.webp": 21970,
	"./agatha/third": 51045,
	"./agatha/third.webp": 51045,
	"./all-devices": 73365,
	"./all-devices.webp": 73365,
	"./app-download": 32937,
	"./app-download.webp": 32937,
	"./app/app-icon": 84608,
	"./app/app-icon.svg": 84608,
	"./app/appstore": 55745,
	"./app/appstore-dark": 64433,
	"./app/appstore-dark.svg": 64433,
	"./app/appstore.svg": 55745,
	"./app/googleplay": 27801,
	"./app/googleplay-dark": 15945,
	"./app/googleplay-dark.svg": 15945,
	"./app/googleplay.svg": 27801,
	"./backgrounds/error_pages": 78627,
	"./backgrounds/error_pages.jpg": 78627,
	"./backgrounds/free-trial": 79589,
	"./backgrounds/free-trial.webp": 79589,
	"./backgrounds/giftcards/desktop": 31040,
	"./backgrounds/giftcards/desktop.webp": 31040,
	"./backgrounds/giftcards/mobile": 24162,
	"./backgrounds/giftcards/mobile.webp": 24162,
	"./backgrounds/how-maestro-works": 37017,
	"./backgrounds/how-maestro-works-2": 68042,
	"./backgrounds/how-maestro-works-2.webp": 68042,
	"./backgrounds/how-maestro-works-3": 30066,
	"./backgrounds/how-maestro-works-3.webp": 30066,
	"./backgrounds/how-maestro-works-4": 95790,
	"./backgrounds/how-maestro-works-4.webp": 95790,
	"./backgrounds/how-maestro-works-5": 70009,
	"./backgrounds/how-maestro-works-5.webp": 70009,
	"./backgrounds/how-maestro-works-6": 26501,
	"./backgrounds/how-maestro-works-6.webp": 26501,
	"./backgrounds/how-maestro-works-7": 98469,
	"./backgrounds/how-maestro-works-7.webp": 98469,
	"./backgrounds/how-maestro-works.webp": 37017,
	"./bbc-maestro-logo-dark": 68998,
	"./bbc-maestro-logo-dark.png": 68998,
	"./bg-vid-poster": 70906,
	"./bg-vid-poster.jpg": 70906,
	"./blog/character-bio-template": 24970,
	"./blog/character-bio-template.webp": 24970,
	"./blog/wine-template": 61178,
	"./blog/wine-template.webp": 61178,
	"./business/gifting": 82635,
	"./business/gifting.webp": 82635,
	"./business/hero": 18101,
	"./business/hero-mobile": 86577,
	"./business/hero-mobile.webp": 86577,
	"./business/hero.webp": 18101,
	"./business/value-prop": 52669,
	"./business/value-prop.webp": 52669,
	"./campaign/badge-as-banner": 41403,
	"./campaign/badge-as-banner.jpg": 41403,
	"./campaign/badge-lg": 94571,
	"./campaign/badge-lg.jpg": 94571,
	"./campaign/badge-sm": 76753,
	"./campaign/badge-sm.jpg": 76753,
	"./campaign/banner-lg": 99150,
	"./campaign/banner-lg.jpg": 99150,
	"./campaign/banner-sm": 81078,
	"./campaign/banner-sm.jpg": 81078,
	"./campaign/bottom-banner-lg": 4958,
	"./campaign/bottom-banner-lg.jpg": 4958,
	"./campaign/bottom-banner-sm": 11851,
	"./campaign/bottom-banner-sm.jpg": 11851,
	"./campaign/payment-banner": 48311,
	"./campaign/payment-banner.jpg": 48311,
	"./campaign/popup-lg": 33670,
	"./campaign/popup-lg.jpg": 33670,
	"./campaign/popup-sm": 48805,
	"./campaign/popup-sm.jpg": 48805,
	"./campaign/valentines-marco": 34652,
	"./campaign/valentines-marco-mobile": 40403,
	"./campaign/valentines-marco-mobile.jpg": 40403,
	"./campaign/valentines-marco.jpg": 34652,
	"./cards/amex-logo": 43183,
	"./cards/amex-logo.png": 43183,
	"./cards/amex-logo.svg": 23928,
	"./cards/diners-logo": 78405,
	"./cards/diners-logo.png": 78405,
	"./cards/diners-logo.svg": 92466,
	"./cards/discover-logo": 69773,
	"./cards/discover-logo.png": 69773,
	"./cards/discover-logo.svg": 68666,
	"./cards/jcb-logo": 57381,
	"./cards/jcb-logo.png": 57381,
	"./cards/jcb-logo.svg": 72225,
	"./cards/mastercard-logo": 206,
	"./cards/mastercard-logo.png": 206,
	"./cards/mastercard-logo.svg": 33184,
	"./cards/unionpay-logo": 8325,
	"./cards/unionpay-logo.png": 8325,
	"./cards/unionpay-logo.svg": 16950,
	"./cards/visa-logo": 60945,
	"./cards/visa-logo.png": 60945,
	"./cards/visa-logo.svg": 6660,
	"./checkout/14-day-money-back-guarantee": 47546,
	"./checkout/14-day-money-back-guarantee.png": 47546,
	"./checkout/30-day-money-back-guarantee": 34479,
	"./checkout/30-day-money-back-guarantee.png": 34479,
	"./checkout/cards": 92003,
	"./checkout/cards.svg": 92003,
	"./checkout/photo-maestri": 28027,
	"./checkout/photo-maestri.png": 28027,
	"./course-card": 96269,
	"./course-card.webp": 96269,
	"./course_categories/art-design": 7304,
	"./course_categories/art-design.png": 7304,
	"./course_categories/art-design.webp": 51764,
	"./course_categories/business": 23665,
	"./course_categories/business.png": 23665,
	"./course_categories/business.webp": 24027,
	"./course_categories/film-tv-and-the-stage": 60402,
	"./course_categories/film-tv-and-the-stage.png": 60402,
	"./course_categories/film-tv-and-the-stage.webp": 87700,
	"./course_categories/food-and-drink": 81050,
	"./course_categories/food-and-drink.png": 81050,
	"./course_categories/food-and-drink.webp": 85906,
	"./course_categories/home-and-lifestyle": 63014,
	"./course_categories/home-and-lifestyle.png": 63014,
	"./course_categories/home-and-lifestyle.webp": 31945,
	"./course_categories/music": 42445,
	"./course_categories/music.png": 42445,
	"./course_categories/music.webp": 30672,
	"./course_categories/personal_development": 66430,
	"./course_categories/personal_development.webp": 66430,
	"./course_categories/wellness": 25561,
	"./course_categories/wellness.png": 25561,
	"./course_categories/wellness.webp": 12659,
	"./course_categories/writing": 3215,
	"./course_categories/writing.png": 3215,
	"./course_categories/writing.webp": 34089,
	"./emails/b2b/expired-header-1152x1152": 1351,
	"./emails/b2b/expired-header-1152x1152.jpg": 1351,
	"./emails/b2b/redeemed-header-686x714": 26302,
	"./emails/b2b/redeemed-header-686x714.jpg": 26302,
	"./emails/crowne-plaza-header-800x400": 70807,
	"./emails/crowne-plaza-header-800x400.jpg": 70807,
	"./emails/email-logo": 97372,
	"./emails/email-logo-ececec": 88390,
	"./emails/email-logo-ececec.png": 88390,
	"./emails/email-logo-white": 20309,
	"./emails/email-logo-white.png": 20309,
	"./emails/email-logo.svg": 97372,
	"./emails/gifts/corporate-gifting-header": 36615,
	"./emails/gifts/corporate-gifting-header.png": 36615,
	"./emails/gifts/maestros-gallery-1029x999": 77154,
	"./emails/gifts/maestros-gallery-1029x999.jpg": 77154,
	"./emails/subscription-purchase-1200x600": 98617,
	"./emails/subscription-purchase-1200x600.jpg": 98617,
	"./emails/subscription-purchase-800x400": 21324,
	"./emails/subscription-purchase-800x400.jpg": 21324,
	"./emails/upsell-panel-design-1152x1152": 78787,
	"./emails/upsell-panel-design-1152x1152.jpg": 78787,
	"./favicon/apple-touch-icon": 21185,
	"./favicon/apple-touch-icon.png": 21185,
	"./favicon/favicon-16x16": 29594,
	"./favicon/favicon-16x16.png": 29594,
	"./favicon/favicon-32x32": 53183,
	"./favicon/favicon-32x32.png": 53183,
	"./favicon/safari-pinned-tab": 78131,
	"./favicon/safari-pinned-tab.svg": 78131,
	"./gift": 43858,
	"./gift-card-bkg": 54392,
	"./gift-card-bkg.jpg": 54056,
	"./gift-card-bkg.png": 54392,
	"./gift.webp": 43858,
	"./giftcards/all_courses_highlights_reel": 70935,
	"./giftcards/all_courses_highlights_reel.webp": 70935,
	"./giftcards/assorted-gifts": 52410,
	"./giftcards/assorted-gifts-zoomed": 7918,
	"./giftcards/assorted-gifts-zoomed.webp": 7918,
	"./giftcards/assorted-gifts.webp": 52410,
	"./giftcards/corporate-gift-card-background": 19662,
	"./giftcards/corporate-gift-card-background.png": 19662,
	"./giftcards/gift-card-envelope": 88673,
	"./giftcards/gift-card-envelope.webp": 88673,
	"./giftcards/maestro-for-business-horizontal-logo": 37394,
	"./giftcards/maestro-for-business-horizontal-logo.png": 37394,
	"./giftcards/maestro-for-business-stacked-logo": 83852,
	"./giftcards/maestro-for-business-stacked-logo.png": 83852,
	"./glitter-line": 19924,
	"./glitter-line.png": 19924,
	"./hamburger": 31843,
	"./hamburger.svg": 31843,
	"./homepage/header_video_poster": 186,
	"./homepage/header_video_poster.webp": 186,
	"./icons/add": 13051,
	"./icons/add.svg": 13051,
	"./icons/arrow-down": 45431,
	"./icons/arrow-down.svg": 45431,
	"./icons/arrow-left": 50600,
	"./icons/arrow-left.svg": 50600,
	"./icons/award": 90890,
	"./icons/award.svg": 90890,
	"./icons/bar-chart": 61304,
	"./icons/bar-chart.svg": 61304,
	"./icons/battery": 37518,
	"./icons/battery.svg": 37518,
	"./icons/bbc-maestro-logo": 32292,
	"./icons/bbc-maestro-logo.svg": 32292,
	"./icons/bell": 18226,
	"./icons/bell.svg": 18226,
	"./icons/book-open": 2253,
	"./icons/book-open.svg": 2253,
	"./icons/bookmark": 89749,
	"./icons/bookmark.svg": 89749,
	"./icons/briefcase": 8591,
	"./icons/briefcase.svg": 8591,
	"./icons/calendar": 50238,
	"./icons/calendar-date": 82709,
	"./icons/calendar-date.svg": 82709,
	"./icons/calendar.svg": 50238,
	"./icons/camera": 19489,
	"./icons/camera.svg": 19489,
	"./icons/check": 39421,
	"./icons/check-circle": 31781,
	"./icons/check-circle.svg": 31781,
	"./icons/check-shield": 64914,
	"./icons/check-shield.svg": 64914,
	"./icons/check.svg": 39421,
	"./icons/chevron-down": 32597,
	"./icons/chevron-down.svg": 32597,
	"./icons/chevron-left": 93381,
	"./icons/chevron-left-v2": 8250,
	"./icons/chevron-left-v2.svg": 8250,
	"./icons/chevron-left-v3": 92828,
	"./icons/chevron-left-v3.svg": 92828,
	"./icons/chevron-left.svg": 93381,
	"./icons/chevron-right": 67914,
	"./icons/chevron-right-v2": 29278,
	"./icons/chevron-right-v2.svg": 29278,
	"./icons/chevron-right.svg": 67914,
	"./icons/chevron-up": 87960,
	"./icons/chevron-up-v2": 1374,
	"./icons/chevron-up-v2.svg": 1374,
	"./icons/chevron-up.svg": 87960,
	"./icons/clock": 25990,
	"./icons/clock.svg": 25990,
	"./icons/close": 60613,
	"./icons/close-light": 15979,
	"./icons/close-light.svg": 15979,
	"./icons/close.svg": 60613,
	"./icons/cms/bell": 78796,
	"./icons/cms/bell.svg": 78796,
	"./icons/cms/devices": 73524,
	"./icons/cms/devices.svg": 73524,
	"./icons/cms/document": 97478,
	"./icons/cms/document.svg": 97478,
	"./icons/cms/payment": 83615,
	"./icons/cms/payment.svg": 83615,
	"./icons/cms/star": 6798,
	"./icons/cms/star.svg": 6798,
	"./icons/cms/tick": 93655,
	"./icons/cms/tick.svg": 93655,
	"./icons/contactless": 13015,
	"./icons/contactless.svg": 13015,
	"./icons/copy": 43136,
	"./icons/copy.svg": 43136,
	"./icons/cross": 5883,
	"./icons/cross.svg": 5883,
	"./icons/download": 32869,
	"./icons/download.svg": 32869,
	"./icons/edit": 7658,
	"./icons/edit.svg": 7658,
	"./icons/email": 29313,
	"./icons/email.svg": 29313,
	"./icons/eye": 93684,
	"./icons/eye-cross": 87947,
	"./icons/eye-cross.svg": 87947,
	"./icons/eye.svg": 93684,
	"./icons/facebook": 70237,
	"./icons/facebook.svg": 70237,
	"./icons/file-text": 17941,
	"./icons/file-text.svg": 17941,
	"./icons/film": 50235,
	"./icons/film.svg": 50235,
	"./icons/food": 3085,
	"./icons/food.svg": 3085,
	"./icons/form-error": 60491,
	"./icons/form-error.svg": 60491,
	"./icons/gift": 60173,
	"./icons/gift.svg": 60173,
	"./icons/headphones": 52130,
	"./icons/headphones.svg": 52130,
	"./icons/heart": 41413,
	"./icons/heart.svg": 41413,
	"./icons/help": 56253,
	"./icons/help.svg": 56253,
	"./icons/hidden": 29606,
	"./icons/hidden.svg": 29606,
	"./icons/image": 26210,
	"./icons/image.svg": 26210,
	"./icons/info": 1821,
	"./icons/info.svg": 1821,
	"./icons/lightbulb": 15841,
	"./icons/lightbulb.svg": 15841,
	"./icons/lightning-bolt": 19125,
	"./icons/lightning-bolt.svg": 19125,
	"./icons/linkedin": 15272,
	"./icons/linkedin.svg": 15272,
	"./icons/list": 98305,
	"./icons/list.svg": 98305,
	"./icons/loading": 85031,
	"./icons/loading.svg": 85031,
	"./icons/lock": 64573,
	"./icons/lock.svg": 64573,
	"./icons/log-out": 21013,
	"./icons/log-out.svg": 21013,
	"./icons/login": 79669,
	"./icons/login.svg": 79669,
	"./icons/mail": 25019,
	"./icons/mail.svg": 25019,
	"./icons/minus": 36183,
	"./icons/minus.svg": 36183,
	"./icons/note-with-eye": 58248,
	"./icons/note-with-eye.svg": 58248,
	"./icons/notes": 21171,
	"./icons/notes.svg": 21171,
	"./icons/password-hide": 67116,
	"./icons/password-hide.svg": 67116,
	"./icons/password-show": 14906,
	"./icons/password-show.svg": 14906,
	"./icons/pause": 95016,
	"./icons/pause.svg": 95016,
	"./icons/pen": 30332,
	"./icons/pen.svg": 30332,
	"./icons/percent": 29762,
	"./icons/percent.svg": 29762,
	"./icons/play": 81015,
	"./icons/play-button": 84062,
	"./icons/play-button.svg": 84062,
	"./icons/play.svg": 81015,
	"./icons/plus": 2704,
	"./icons/plus.svg": 2704,
	"./icons/present": 9908,
	"./icons/present-v2": 20127,
	"./icons/present-v2.svg": 20127,
	"./icons/present.svg": 9908,
	"./icons/quotes": 21591,
	"./icons/quotes.svg": 21591,
	"./icons/repeat": 49907,
	"./icons/repeat.svg": 49907,
	"./icons/search": 90439,
	"./icons/search.svg": 90439,
	"./icons/share": 77008,
	"./icons/share.png": 77008,
	"./icons/share.svg": 61487,
	"./icons/smartphone": 72003,
	"./icons/smartphone.svg": 72003,
	"./icons/social/email": 7687,
	"./icons/social/email.svg": 7687,
	"./icons/social/facebook-dark": 68207,
	"./icons/social/facebook-dark.svg": 68207,
	"./icons/social/facebook-light": 46498,
	"./icons/social/facebook-light.svg": 46498,
	"./icons/social/instagram-dark": 36907,
	"./icons/social/instagram-dark.svg": 36907,
	"./icons/social/instagram-light": 42322,
	"./icons/social/instagram-light.svg": 42322,
	"./icons/social/twitter-dark": 64299,
	"./icons/social/twitter-dark.svg": 64299,
	"./icons/social/youtube-dark": 50658,
	"./icons/social/youtube-dark.svg": 50658,
	"./icons/social/youtube-light": 72111,
	"./icons/social/youtube-light.svg": 72111,
	"./icons/sparkles": 70867,
	"./icons/sparkles.svg": 70867,
	"./icons/speech-bubble": 87658,
	"./icons/speech-bubble.svg": 87658,
	"./icons/ssl": 44900,
	"./icons/ssl-secure-final": 72887,
	"./icons/ssl-secure-final.png": 72887,
	"./icons/ssl.svg": 44900,
	"./icons/star": 6303,
	"./icons/star.svg": 6303,
	"./icons/star_outline": 21418,
	"./icons/star_outline.svg": 21418,
	"./icons/subtitles": 57960,
	"./icons/subtitles.svg": 57960,
	"./icons/tag": 87175,
	"./icons/tag.svg": 87175,
	"./icons/target": 72491,
	"./icons/target.svg": 72491,
	"./icons/thumbs-up": 99730,
	"./icons/thumbs-up.svg": 99730,
	"./icons/tick": 26613,
	"./icons/tick-circle": 42530,
	"./icons/tick-circle.svg": 42530,
	"./icons/tick-green": 42439,
	"./icons/tick-green.svg": 42439,
	"./icons/tick.svg": 26613,
	"./icons/twitter": 57405,
	"./icons/twitter.svg": 57405,
	"./icons/unlock": 53320,
	"./icons/unlock.svg": 53320,
	"./icons/user": 75159,
	"./icons/user.svg": 75159,
	"./icons/video": 74595,
	"./icons/video-2": 75858,
	"./icons/video-2.svg": 75858,
	"./icons/video.svg": 74595,
	"./insight-1": 63800,
	"./insight-1.jpg": 63800,
	"./insight-2": 47690,
	"./insight-2.jpg": 47690,
	"./insight-3": 3686,
	"./insight-3.jpg": 3686,
	"./insight-4": 25659,
	"./insight-4.jpg": 25659,
	"./linear_icons/credit_card": 18647,
	"./linear_icons/credit_card.svg": 18647,
	"./linear_icons/devices": 83667,
	"./linear_icons/devices.svg": 83667,
	"./linear_icons/document": 53250,
	"./linear_icons/document.svg": 53250,
	"./linear_icons/note_with_eye": 23073,
	"./linear_icons/note_with_eye.svg": 23073,
	"./linear_icons/present": 97243,
	"./linear_icons/present.svg": 97243,
	"./linear_icons/speech_bubble": 92535,
	"./linear_icons/speech_bubble.svg": 92535,
	"./linear_icons/star": 26542,
	"./linear_icons/star.svg": 26542,
	"./linear_icons/video_camera": 52853,
	"./linear_icons/video_camera.svg": 52853,
	"./logo-dark": 36625,
	"./logo-dark-small": 4261,
	"./logo-dark-small.svg": 4261,
	"./logo-dark.svg": 36625,
	"./logo-light": 56749,
	"./logo-light.svg": 56749,
	"./logo-stacked": 48986,
	"./logo-stacked.svg": 48986,
	"./logo-white-and-orange": 87575,
	"./logo-white-and-orange.svg": 87575,
	"./maestri-desktop": 73190,
	"./maestri-desktop.webp": 73190,
	"./maestro-orange": 57661,
	"./maestro-orange.svg": 57661,
	"./my_account/onboarding-empty": 45591,
	"./my_account/onboarding-empty.webp": 45591,
	"./not-found": 50530,
	"./not-found.png": 50530,
	"./partners/david-lloyd-logo": 58225,
	"./partners/david-lloyd-logo.png": 58225,
	"./partners/ey-logo": 12074,
	"./partners/ey-logo.svg": 12074,
	"./partners/hero": 21894,
	"./partners/hero-2": 9898,
	"./partners/hero-2-small": 42826,
	"./partners/hero-2-small.webp": 42826,
	"./partners/hero-2.webp": 9898,
	"./partners/hero-collage": 79041,
	"./partners/hero-collage-mobile": 67299,
	"./partners/hero-collage-mobile.webp": 67299,
	"./partners/hero-collage.webp": 79041,
	"./partners/hero-small": 34482,
	"./partners/hero-small.webp": 34482,
	"./partners/hero.webp": 21894,
	"./partners/leadership-wellness-logo": 14384,
	"./partners/leadership-wellness-logo.png": 14384,
	"./partners/learning-event-logo": 93560,
	"./partners/learning-event-logo.png": 93560,
	"./partners/vodafone": 9538,
	"./partners/vodafone.png": 9538,
	"./placeholder": 66022,
	"./placeholder.jpg": 66022,
	"./player/close": 12330,
	"./player/close.svg": 12330,
	"./player/fullscreen": 71571,
	"./player/fullscreen.svg": 71571,
	"./player/loader": 67372,
	"./player/loader.png": 67372,
	"./player/next": 42597,
	"./player/next.svg": 42597,
	"./player/pause": 77245,
	"./player/pause.svg": 77245,
	"./player/play": 62330,
	"./player/play-small": 98009,
	"./player/play-small.svg": 98009,
	"./player/play.svg": 62330,
	"./player/replay": 68058,
	"./player/replay.svg": 68058,
	"./player/skip-back": 96428,
	"./player/skip-back.svg": 96428,
	"./player/skip-forward": 1743,
	"./player/skip-forward.svg": 1743,
	"./player/subtitle": 24301,
	"./player/subtitle.svg": 24301,
	"./player/thumbnail-placeholder": 13464,
	"./player/thumbnail-placeholder.jpg": 13464,
	"./player/volume": 22559,
	"./player/volume-muted": 73319,
	"./player/volume-muted.svg": 73319,
	"./player/volume.svg": 22559,
	"./promo-1": 51253,
	"./promo-1.jpg": 51253,
	"./renewal_discount/banner_image": 74934,
	"./renewal_discount/banner_image.webp": 74934,
	"./subscription-upgrade": 8138,
	"./subscription-upgrade.webp": 8138,
	"./subscription/hero": 86930,
	"./subscription/hero-mobile": 1096,
	"./subscription/hero-mobile.webp": 1096,
	"./subscription/hero.webp": 86930,
	"./subscriptions": 57802,
	"./subscriptions.jpg": 57802,
	"./subscriptions/selection-of-courses-cards": 70341,
	"./subscriptions/selection-of-courses-cards.webp": 70341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37939;